import type { FC } from 'react';
import * as React from 'react';

import { useNetworkTracking } from '@xing-com/crate-network-tracking';

import { DirectConnections } from './components/direct-connections/direct-connections';
import { DiscoverNetwork } from './components/discover-network';
import { GetDiscovered } from './components/get-discovered';
import { HiringSection } from './components/hiring-section/hiring-section';
import { TopRecruiters } from './components/top-recruiters';

export const Entry: FC = () => {
  const { trackNetworkNWT } = useNetworkTracking();

  React.useEffect(() => {
    trackNetworkNWT({
      event: 'viewed_screen',
    });
  }, [trackNetworkNWT]);

  return (
    <div style={{ overflow: 'hidden' }} data-qa="network-entry-logged-out">
      <TopRecruiters />
      <GetDiscovered />
      <DirectConnections />
      <DiscoverNetwork />
      <HiringSection />
    </div>
  );
};
